import React, { useState } from "react";
import "../../css/CRUDModal.css";
import ButtonTriangle from "../../assets/Icons/Button Triangle.png";
import { useForm, Controller } from "react-hook-form";
import { Box, CircularProgress } from "@mui/material";
import CustomAlert from "../../helpers/CustomAlert";
import { axiosPostApi } from "../../helpers/interceptorServices";
import { apiList } from "../../helpers/apiList";
import OrangeFilterIcon from "../../assets/Icons/Orange Filter.png";
import CrossIcon from "../../assets/Icons/cross_svg.svg";
import LeftCircle from "../../assets/Icons/Left circle B.png";
import RightCircle from "../../assets/Icons/Right circle A.png";

const ReportCourierFilterModal = ({
  show,
  handleClose,
  setCustomerData,
  setPageDetails,
  setNoData,
  pageSize,
  currentPage,
  filterData,
  setFilterData,
  handleReset,
  defaultFilterData,
}) => {
  const {
    control,
    handleSubmit,
    formState: { errors },
    reset,
  } = useForm({
    defaultValues: filterData,
    mode: "onChange",
  });

  const [selectedTab, setSelectedTab] = useState("Date Range");
  const [loading, setLoading] = useState(false);
  const loggedInUserName = sessionStorage.getItem("username");

  const handleTabChange = (e, tabName) => {
    e.preventDefault();
    setSelectedTab(tabName);
  };

  const formatDate = (dateStr) => {
    if (!dateStr) return "";
    const [year, month, day] = dateStr.split("-");
    return `${day}-${month}-${year}`;
  };

  const onSubmit = () => {
    fetchReportCourierData(currentPage);
  };

  const fetchReportCourierData = async (currentPage) => {
    setLoading(true);
    try {
      const requestBody = {
        username: loggedInUserName,
        fromDate: formatDate(filterData.fromDate),
        toDate: formatDate(filterData.toDate),
        oemNames: filterData.oemNames || [],
      };

      const response = await axiosPostApi(
        `${apiList.FETCH_REPORT_COURIER_DATA}?pageSize=${pageSize}&pageNo=${1}`,
        requestBody
      );

      if (
        response?.data?.status === true &&
        response?.data?.respCode === "00"
      ) {
        setPageDetails(response?.data?.pageDetails);
        setCustomerData(response?.data?.data || []);
        setNoData((response?.data?.data || []).length === 0);
        handleClose();
      } else {
        CustomAlert({
          title: "Failed",
          text:
            response?.data?.message ||
            "There was an issue processing the request.",
          icon: "error",
          confirmButtonText: "Retry",
        });
        setCustomerData([]);
        setNoData(true);
      }
    } catch (error) {
      CustomAlert({
        title: "Error",
        text: "An error occurred while fetching the data. Please try again later.",
        icon: "error",
        confirmButtonText: "Retry",
      });
    } finally {
      setLoading(false);
    }
  };

  const getTodayDate = () => {
    const today = new Date();
    const year = today.getFullYear();
    const month = String(today.getMonth() + 1).padStart(2, "0");
    const day = String(today.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
  };

  const onReset = () => {
    handleReset();
    reset(defaultFilterData);
  };

  // OEM options
  const oemOptions = ["Blue Dart", "DTDC", "Delivery"];

  const handleSelectAll = () => {
    setFilterData((prev) => ({
      ...prev,
      oemNames: oemOptions,
    }));
  };

  const handleClearAll = () => {
    setFilterData((prev) => ({
      ...prev,
      oemNames: [],
    }));
  };

  const toggleOemSelection = (oem) => {
    setFilterData((prev) => {
      const selected = prev.oemNames || [];
      return {
        ...prev,
        oemNames: selected.includes(oem)
          ? selected.filter((s) => s !== oem)
          : [...selected, oem],
      };
    });
  };

  return (
    <>
      {show && (
        <div
          style={{
            position: "fixed",
            top: 0,
            right: 0,
            bottom: 0,
            left: 0,
            backgroundColor: "rgba(0,0,0,0.4)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 1060,
          }}
        >
          <div className="modal-dialog" role="document">
            <div
              className="modal-content"
              style={{
                width: "850px",
                borderRadius: "24px",
                padding: "24px",
                backgroundColor: "#FFF",
                border: "1px solid rgba(0, 0, 0, 0.175)",
              }}
            >
              <img
                src={LeftCircle}
                alt="leftImg"
                className="absolute left-0 bottom-0 w-[110px] h-[105px]"
              />
              <img
                src={RightCircle}
                alt="leftImg"
                className="absolute right-0 top-0 w-[110px] h-[105px]"
              />
              {/* Header */}
              <div
                className="modal-header"
                style={{
                  padding: "1rem 1rem",
                  justifyContent: "space-between",
                }}
              >
                <div className="flex items-center gap-3">
                  <img
                    src={OrangeFilterIcon}
                    alt="filter"
                    className="h-[21px]"
                  />
                  <h5 className="modal-title main-title font-semibold">
                    Report Courier Filters
                  </h5>
                </div>
                <img
                  src={CrossIcon}
                  alt="close"
                  className="w-[30px] h-[30px] cursor-pointer z-20"
                  onClick={handleClose}
                />
              </div>

              {/* Body */}
              <Box component="form" onSubmit={handleSubmit(onSubmit)}>
                <div
                  className="scoped-modal modal-body"
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    width: "100%",
                  }}
                >
                  <div className="tab-container">
                    {/* Tab List */}
                    <ul className="tab-list">
                      {["Date Range", "OEM Name"].map((tab) => (
                        <div className="tab-wrapper" key={tab}>
                          <li
                            className={
                              selectedTab === tab
                                ? "tab-item selected"
                                : "tab-item"
                            }
                          >
                            <button
                              className={`tab-button ${
                                selectedTab === tab ? "active" : ""
                              }`}
                              onClick={(e) => handleTabChange(e, tab)}
                            >
                              {tab}
                            </button>
                          </li>
                          {selectedTab === tab && (
                            <img
                              src={ButtonTriangle}
                              alt="tri"
                              className="tab-triangle"
                            />
                          )}
                        </div>
                      ))}
                    </ul>

                    {/* Tab Content */}
                    <div className="flex-grow h-fit bg-[#ffe8d4] rounded-[9px] p-3">
                      {/* Date Range Tab */}
                      {selectedTab === "Date Range" && (
                        <div
                          className="dateGrid"
                          style={{
                            display: "flex",
                            flexDirection: "row",
                            gap: "1rem",
                          }}
                        >
                          {/* From Date */}
                          <Controller
                            name="fromDate"
                            control={control}
                            render={({ field }) => (
                              <div className="dateField" style={{ flex: 1 }}>
                                <div className="dateInputWrapper">
                                  <input
                                    {...field}
                                    type="date"
                                    className="dateInput"
                                    max={getTodayDate()}
                                    value={filterData?.fromDate || ""}
                                    onChange={(e) => {
                                      field.onChange(e);
                                      setFilterData((prev) => ({
                                        ...prev,
                                        fromDate: e.target.value,
                                      }));
                                    }}
                                  />
                                </div>
                              </div>
                            )}
                          />

                          {/* To Date */}
                          <Controller
                            name="toDate"
                            control={control}
                            render={({ field }) => (
                              <div className="dateField" style={{ flex: 1 }}>
                                <div className="dateInputWrapper">
                                  <input
                                    {...field}
                                    type="date"
                                    className="dateInput"
                                    max={getTodayDate()}
                                    value={filterData?.toDate || ""}
                                    onChange={(e) => {
                                      field.onChange(e);
                                      setFilterData((prev) => ({
                                        ...prev,
                                        toDate: e.target.value,
                                      }));
                                    }}
                                  />
                                </div>
                              </div>
                            )}
                          />
                        </div>
                      )}

                      {/* OEM Name Tab */}
                      {selectedTab === "OEM Name" && (
                        <div className="dateField">
                          <div className="dateInputWrapper">
                            {/* Select/Clear All Row */}
                            <div className="flex justify-between items-center px-[0.75rem] py-2 border-b border-black border-dashed mb-2">
                              <label className="flex items-center gap-2 cursor-pointer text-[0.9rem] font-semibold text-[#000000]">
                                <input
                                  type="checkbox"
                                  checked={
                                    (filterData?.oemNames || []).length ===
                                    oemOptions.length
                                  }
                                  onChange={() =>
                                    (filterData?.oemNames || []).length ===
                                    oemOptions.length
                                      ? handleClearAll()
                                      : handleSelectAll()
                                  }
                                />
                                Select all
                              </label>
                              <button
                                type="button"
                                className="text-[#00008B] bg-transparent border-none text-[0.9rem] font-medium cursor-pointer"
                                onClick={handleClearAll}
                              >
                                Clear all
                              </button>
                            </div>

                            {/* OEM Checkboxes */}
                            {oemOptions.map((oem) => (
                              <label
                                key={oem}
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                  gap: "0.5rem",
                                  padding: "0.5rem 0.75rem",
                                  cursor: "pointer",
                                  fontSize: "0.9rem",
                                  fontWeight: "500",
                                }}
                              >
                                <input
                                  type="checkbox"
                                  value={oem}
                                  checked={(
                                    filterData?.oemNames || []
                                  ).includes(oem)}
                                  onChange={() => toggleOemSelection(oem)}
                                />
                                {oem}
                              </label>
                            ))}
                          </div>
                        </div>
                      )}
                    </div>
                  </div>
                </div>

                {/* Footer */}
                <div
                  className="scoped-modal"
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    padding: "12px",
                    paddingBottom: "0px",
                    gap: "16px",
                  }}
                >
                  <div className="buttonContainer">
                    <button
                      type="button"
                      className="flex btn btn-back w-[133px] h-[33px] !rounded-lg items-center justify-center"
                      onClick={onReset}
                    >
                      Clear
                    </button>
                  </div>
                  <div className="buttonContainer">
                    <button
                      type="submit"
                      className="flex btn btn-submit w-[133px] h-[33px] !rounded-lg items-center justify-center"
                      disabled={loading}
                    >
                      {loading ? (
                        <CircularProgress
                          style={{ width: "20px", height: "20px" }}
                        />
                      ) : (
                        "Apply"
                      )}
                    </button>
                  </div>
                </div>
              </Box>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default ReportCourierFilterModal;
